<template>
  <p
    :class="classes"
  ><b>Datum/tijd melding: </b>{{ createDate }}</p>
  <p
      :class="classes"
  ><b>Adres: </b> {{ report.address }}</p>
  <p
    :class="classes"
  ><b>Postcode: </b>{{ report.zipCode }}</p>
  <p
  :class="classes"
  ><b>Plaats: </b>{{ report.city }}</p>
</template>

<script>

import ReportDetailStore from '@/store/pages/Report/report-detail-store';

import { getDateString, getTimeString } from '@/helpers/datetime';

export default {
  computed: {
    report() {
      return ReportDetailStore.getters.isLoaded
        ? ReportDetailStore.getters.report
        : {
          createDate: 'Placeholder datum',
          address: 'Straat 01',
          zipCode: '0000XX',
          city: 'Plaatsnaam',
        };
    },

    createDate() {
      if (!ReportDetailStore.getters.isLoaded) return '';

      let date = new Date(ReportDetailStore.getters.report.createDate);

      return `${getDateString(date)} // ${getTimeString(date)}`;
    },

    classes() {
      return {
        'mb-0': true,
        'placeholder': ReportDetailStore.getters.isLoading,
      }
    },
  }, 
}
</script>